module.exports = __webpack_public_path__ + "static/media/thinkplus.33d9dccf.svg";